package kz.dentalcrm.app.screens.splash

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import kz.dentalcrm.app.navigation.AppNavigator
import kz.dentalcrm.app.navigation.LoginRoute
import kz.dentalcrm.app.navigation.MainRoute
import kz.dentalcrm.app.screens.splash.mvi.SplashViewSideEffect
import org.koin.compose.koinInject
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun SplashScreen() {
    val navigator: AppNavigator = koinInject()
    val viewModel: SplashViewModel = koinViewModel()

    LaunchedEffect(viewModel.effect) {
        viewModel.effect.collect { effect ->
            when (effect) {
                SplashViewSideEffect.NavigateToMain -> navigator.navigateAndClearBackStack(MainRoute)
                SplashViewSideEffect.NavigateToLogin -> navigator.navigateAndClearBackStack(LoginRoute)
            }
        }
    }

    Box(
        modifier = Modifier.fillMaxSize()
            .background(
                brush = Brush.verticalGradient(
                    listOf(
                        Color(0xFFf6f6f6),
                        Color(0xFF020022),
                    )
                )
            )
    )
}
